export const UNKNOWN_LICENSE = 'unknown_license';
export const EXCEEDED_SESSIONS_LIMIT = 2;
